var localForage = require('localforage');
var _ = require('lodash');
var moment = require('moment-timezone');
export default {
    install: function (Vue, options) {
        let sync = {};
        const lastSyncKey = 'syncData';
        // inizializzo il sistema
        localForage.config(options)
        Vue.mixin({
            mounted() {
                /**
                 * Ritorna tutti gli elementi di sincronizzazione
                 * @returns {Promise<Object>}
                 */
                sync.getAllLastSync = () => {
                    return new Promise((resolve, reject) => {
                        return localForage.getItem(lastSyncKey, (err, value) => {
                            if (err !== null)
                                reject(err);
                            if (value == null)
                                resolve({});
                            resolve(value);
                        });
                    });
                };
                /**
                 * Ritorna l'ultima sincronizzazione di una singola tabella
                 * @param key
                 * @returns {Promise<unknown>}
                 */
                sync.getLastSync = (key) => {
                    return new Promise((resolve, reject) => {
                        return sync.getAllLastSync()
                            .then((data) => {
                                resolve(data[key] || 0);
                            })
                            .catch((err) => {
                                reject(err);
                            })
                    });
                };
                /**
                 * Modifica la data dell'ultima sincronizzazione con la data
                 * corrente per una singola tabella
                 * @param key
                 * @returns {Promise<unknown>}
                 */
                sync.updateLastSync = (key) => {
                    return new Promise((resolve) => {
                        return sync.getAllLastSync()
                            .then((data) => {
                                data[key] = moment().tz("Europe/Rome").format("X");
                                localForage.setItem(lastSyncKey, data, () => {
                                    resolve(true);
                                });
                            });
                    });
                };
                /**
                 * Prendo i dati di una tabella
                 * @param table
                 * @returns {Promise<unknown>}
                 */
                sync.getTable = (table) => {
                    return new Promise((resolve, reject) => {
                        return localForage.getItem(table, (err, value) => {
                            if (err !== null)
                                reject(err);
                            if (value == null)
                                resolve([]);
                            resolve(value);
                        });
                    });
                };
                /**
                 * Salvo i dati di una tabella
                 * @param table
                 * @param data
                 * @returns {Promise<unknown>}
                 */
                sync.saveTable = (table, data) => {
                    return new Promise((resolve, reject) => {
                        return localForage.setItem(table, data, (err) => {
                            if (err !== null)
                                reject(err);
                            resolve();
                        });
                    });
                };
                /**
                 * Sincronizza i dati di una tabella
                 * @param table
                 * @param items
                 * @returns {Promise<unknown>}
                 */
                sync.syncronizeTable = (table, updateStatusCallback) => {
                    updateStatusCallback('start');
                    // inizializzo le variabili necessarie
                    updateStatusCallback('init', `${table}`);
                    let lastSync = 0;
                    let items = [];
                    let itemsToClean = [];
                    sync.getLastSync(table)// prendo la data dell'ultima sincronizzazione
                        .then((dataLastSync) => {
                            lastSync = dataLastSync;
                            // prendo gli elementi modificati dopo lastSync
                            sync.getTable(table)
                                .then((dataItems) => {
                                    dataItems.map((d) => {
                                        let lastUpdate = moment(d.updated_at).tz("Europe/Rome").format("X");
                                        if (lastUpdate >= lastSync) {
                                            items.push(d);
                                        } else {
                                            itemsToClean.push(d);
                                        }
                                    });
                                    /*console.log(table + ": " + (JSON.stringify(itemsToClean).length / 1024).toFixed(2) + " Kb");
                                    itemsToClean.map(itc => {
                                        if(table == 'customers') {
                                        }
                                    });*/
                                    // ho preso gli elementi da spedire al server
                                    let data = {
                                        table: table, // la tabella da sincronizzare
                                        lastsync: lastSync, // l'ultima sincronizzazione
                                        items: items // i dati da modificare
                                    };
                                    // invio il tutto al server
                                    this.api.post(`/sync`, data, false)
                                        .then((result) => {
                                            if (result && result.success && result.data && result.data.count > 0) {
                                                let counter = 0;
                                                let dataTable = [];
                                                let dataTableId = [];
                                                result.data.data.map((item) => {
                                                    counter++;
                                                    updateStatusCallback('item', `${counter}/${result.data.count}`);
                                                    dataTable.push(item);
                                                    dataTableId.push(item["id"]);
                                                });
                                                // prendo i dati del database
                                                sync.getTable(table)
                                                    .then(results => {
                                                        // elimino dalla tabella i dati che verranno sostituiti
                                                        let newData = _.remove(results, (n) => {
                                                            return !(dataTableId.indexOf(n["id"]) >= 0);
                                                        });
                                                        // aggiungo i nuovi dati aggiornati
                                                        dataTable.map((item) => {
                                                            newData.push(item);
                                                        });
                                                        // salvo la tabella
                                                        sync.saveTable(table, newData)
                                                            .then(() => {
                                                                // salvo il lastsync
                                                                sync.updateLastSync(table)
                                                                    .then(() => {
                                                                        updateStatusCallback('end');
                                                                    })
                                                                    .catch(() => {
                                                                        updateStatusCallback('error');
                                                                    });
                                                            })
                                                            .catch((err) => {
                                                                updateStatusCallback('error', err);
                                                            });
                                                    })
                                                    .catch((err) => {
                                                        updateStatusCallback('error', err);
                                                    });
                                            } else {
                                                if (result.success && result.data.count == 0) {
                                                    sync.updateLastSync(table)
                                                        .then(() => {
                                                            updateStatusCallback('end');
                                                        })
                                                        .catch(() => {
                                                            updateStatusCallback('error');
                                                        });
                                                } else {
                                                    updateStatusCallback('error');
                                                }
                                            }
                                        })
                                        .catch((error) => {
                                            updateStatusCallback('error', error);
                                        });
                                });
                        })
                        .catch((err) => {
                            updateStatusCallback('error', `${err}`);
                        });
                }
                /**
                 * Definisco delle funzioni per il salvataggio di dati temporanei
                 */
                const tmpFunctions = {
                    /**
                     * Inserisce un valore nel database
                     * @param name
                     * @param value
                     */
                    update: (name, value) => {
                        localForage.setItem(`tmp_${name}`, value);
                    },
                    /**
                     * Rimuove il valore nel DB
                     * @param name
                     */
                    remove: (name) => {
                        localForage.removeItem(`tmp_${name}`);
                    },
                    /**
                     * Prende il valore nel DB
                     * @param name
                     */
                    get: (name) => {
                        return new Promise((resolve, reject) => {
                            return localForage.getItem(`tmp_${name}`)
                                .then((data) => {
                                    resolve(data || null);
                                })
                                .catch((err) => {
                                    reject(err);
                                })
                        });
                    },
                    addItem: (name, item) => {
                        return new Promise((resolve, reject) => {
                            return localForage.getItem(`arr_${name}`)
                                .then((data) => {
                                    data = data || [];
                                    data = (data == null) ? [] : data;
                                    item.data_salvataggio = new Date();
                                    data.push(item);
                                    localForage.setItem(`arr_${name}`, data);
                                    resolve();
                                })
                                .catch((err) => {
                                    reject(err);
                                })
                        });
                    },
                    removeItem: (name, index) => {
                        return new Promise((resolve, reject) => {
                            return localForage.getItem(`arr_${name}`)
                                .then((data) => {
                                    data = data || [];
                                    data = (data == null) ? [] : data;
                                    data.splice(index, 1);
                                    localForage.setItem(`arr_${name}`, data);
                                    resolve();
                                })
                                .catch((err) => {
                                    reject(err);
                                })
                        });
                    },
                    getItems: (name) => {
                        return new Promise((resolve, reject) => {
                            return localForage.getItem(`arr_${name}`)
                                .then((data) => {
                                    data = data || [];
                                    data = (data == null) ? [] : data;
                                    resolve(data);
                                })
                                .catch((err) => {
                                    reject(err);
                                })
                        });
                    }
                };
                sync.tempData = tmpFunctions;
            }
        });
        Vue.prototype.sync = sync;
    }
}
